import { render, staticRenderFns } from "./JoinAgreeBox.vue?vue&type=template&id=265d5673"
import script from "./JoinAgreeBox.vue?vue&type=script&lang=js"
export * from "./JoinAgreeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports